module.exports = __webpack_public_path__ + "static/img/game-TowerOfFantasy_phone.e0803f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-TowerOfFantasy_phone.jpg
// module id = Ay17
// module chunks = 0